import Vue from 'vue';
window.Vue = Vue
import MaskedInput from 'vue-masked-input'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'


const app = new Vue({
    el: '#audit',
    data() {
        return {
            phone_mask_base: '11 11 11 11 11',
            phone_mask: '11 11 11 11 11',
            countries: window.Data.countries
        }
    },
    components: {
        MaskedInput, VueBootstrapTypeahead
    },
    methods: {
        inputLastName(event) {
            event.target.value = event.target.value.match(/[A-Za-z\s-]+/)[0];
        },
        inputFirstName(event) {
            event.target.value = event.target.value.match(/[A-Za-z\s-]+/)[0];
        },
        findCountry(country) {
            axios.post(`/get-phone-code`, {
                country: country
            }).then(
                response => {
                    if(country === 'France'){
                        this.phone_mask = "(0) 1 11 11 11 11";
                    }
                    else{
                        this.phone_mask = "+" + response.data.phone_code + " 1 11 11 11 11";
                    }
                }
            );
        },
    }

});
